var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubsLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#4649E5",
    fillOpacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    width: 38,
    height: 38,
    rx: 7.6,
    fill: "#4649E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7028 35.5H47.4373L35.4949 46.7733C35.45 46.9 35.3961 47.1871 35.5398 47.3222C35.6835 47.4573 36.0187 47.3785 36.1683 47.3222C39.1315 44.62 45.1027 39.1311 45.1027 39.1311C45.1027 39.1311 45.422 38.9115 45.6415 38.7933C46.7672 38.1874 47.6357 38.1087 48.9189 38.2867C50.5371 38.5111 51.5831 39.0462 52.5106 40.3133C53.3646 41.4802 53.526 42.457 53.3187 43.86C53.1556 44.9644 52.5106 46.0415 52.1065 46.4778C51.7025 46.9141 43.4864 54.5 43.4864 54.5H36.7071L48.5597 43.3956C48.6196 43.2126 48.644 42.9078 48.425 42.7622C48.2084 42.6182 47.8713 42.7904 47.7516 42.8467C45.1326 45.3659 39.8588 50.4129 39.7151 50.4467C39.5356 50.4889 39.4458 50.7 38.1438 51.46C37.1022 52.068 35.2854 51.9385 34.5072 51.7978C33.8188 51.5585 32.5735 51.105 31.7685 50.1933C30.8156 49.1142 30.6461 48.1244 30.6012 46.7733C30.5653 45.6924 31.3644 44.3807 31.7685 43.86L40.7028 35.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsLogin);
export default __webpack_public_path__ + "static/media/subsLogin.af7fd17fcf11029cbf481a269d0051c6.svg";
export { ForwardRef as ReactComponent };